<template>
    <div class="field">
        <label v-if=label class="field__label">{{ label }}</label>

        <input :type="type" class="field__input" :placeholder="placeholder" ref="field" required />
    </div>
</template>

<script>
export default {
    name: "InputField",
    props: {
        label: String,
        placeholder: String,
        type: {
            type: String,
            default: 'text'
        }
    },
    methods: {
        getValue() {
            return this.$refs.field.value;
        }
    }
}
</script>

<style scoped lang="stylus">
</style>